export default __webpack_public_path__ + "static/media/i_bus-low_gn.cc5f4ed1.svg";